/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/Adunit/theme';

export const AdunitTheme = theme;
